import { api } from '../creat-api'
/**
 * 节目管理
 * 节目列表
 **/
export function fetchPrograms (params) {
  return api({
    url: '/programs',
    params
  })
}
// vod节目 播放量
export function getProgramPlayCount (params) {
  return api({
    method: 'POST',
    url: '/program/getProgramPlayCount',
    data: params
  })
}
// 获取发布状态
export function fetchPushFlag (params) {
  return api({
    url: `/programs/pushFlag/${params.id}?companyId=${params.companyId}`
  })
}
// 获取节目集发布状态
export function fetchSetsPushFlag (params) {
  return api({
    url: `/programSets/pushFlag/${params.id}?companyId=${params.companyId}`
  })
}
// 单个节目送审
export function fetchSingleProgram (params) {
  return api({
    method: 'POST',
    url: '/audit/singleProgram',
    data: params
  })
}
// 批量删除节目
export function fetchProgramsDelete (params) {
  return api({
    method: 'DELETE',
    url: `/programs/${params.id}?updateBy=${params.updateBy}`
  })
}
// 批量送审
export function fetchAuditProgram (params) {
  return api({
    method: 'POST',
    url: '/audit/program',
    data: params
  })
}
// 新增节目
export function fetchNewPrograms (params) {
  return api({
    method: 'POST',
    url: '/programs',
    data: params
  })
}
// 编辑节目
export function fetchPutPrograms (params) {
  return api({
    method: 'PUT',
    url: '/programs',
    data: params
  })
}
